import { useState } from "react";

const ImageWithPlaceholder = ({ src, alt }) => {
	const [loaded, setLoaded] = useState(false);

	return (
		<div style={{ position: "relative" }}>
			<figure className="sixteen-nine-img">
				{/* Skeleton shimmer */}
				<div
					style={{
						background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)",
						backgroundSize: "400% 100%",
						animation: "skeleton-loading 1.4s ease infinite",
						width: "100%",
						height: "100%",
						position: "absolute",
						top: 0,
						left: 0,
						opacity: loaded ? 0 : 1,
						transition: "opacity 0.5s ease",
					}}
				/>

				<img
					src={src}
					alt={alt}
					onLoad={() => setLoaded(true)}
					style={{
						width: "100%",
						height: "100%",
						objectFit: "cover",
						opacity: loaded ? 1 : 0,
						transition: "opacity 0.5s ease",
						display: "block",
					}}
				/>

				<style>
					{`
					@keyframes skeleton-loading {
						0% { background-position: 100% 0; }
						100% { background-position: -100% 0; }
					}
					`}
				</style>
			</figure>
		</div>
	);
};

export default ImageWithPlaceholder;
